export const blockIconsHardwareKeyboardReturnNew = (
	<span className='material-symbols-outlined'>keyboard_return</span>
);
